import { required } from 'vuelidate/lib/validators'

let formData = {
  kidneyProblems: {
    label: 'Problemas renais',
    name: 'kidneyProblems',
    type: 'text',
    value: ''
  },
  jointProblemsOrRheumatism: {
    label: 'Problemas articulares ou reumatismo',
    name: 'jointProblemsOrRheumatism',
    type: 'text',
    value: ''
  },
  heartProblems: {
    label: 'Problemas cardíacos',
    name: 'heartProblems',
    type: 'text',
    value: ''
  },
  breathingProblems: {
    label: 'Problemas respiratórios',
    name: 'breathingProblems',
    type: 'text',
    value: ''
  },
  stomachProblems: {
    label: 'Problemas gástricos',
    name: 'stomachProblems',
    type: 'text',
    value: ''
  },
  allergies: {
    label: 'Alergias',
    name: 'allergies',
    type: 'text',
    value: ''
  },
  isHepatitis: {
    label: 'Hepatite',
    name: 'isHepatitis',
    type: 'radio',
    value: null,
    radios: [
      {
        label: 'Sim',
        value: 1
      },
      {
        label: 'Não',
        value: 0
      }
    ]
  },
  isPregnancy: {
    label: 'Gravidez',
    name: 'isPregnancy',
    type: 'radio',
    value: null,
    radios: [
      {
        label: 'Sim',
        value: 1
      },
      {
        label: 'Não',
        value: 0
      }
    ]
  },
  isDiabetes: {
    label: 'Diabetes',
    name: 'isDiabetes',
    type: 'radio',
    value: null,
    radios: [
      {
        label: 'Sim',
        value: 1
      },
      {
        label: 'Não',
        value: 0
      }
    ]
  },
  isHealingProblems: {
    label: 'Problemas de cicatrização',
    name: 'isHealingProblems',
    type: 'radio',
    value: null,
    radios: [
      {
        label: 'Sim',
        value: 1
      },
      {
        label: 'Não',
        value: 0
      }
    ]
  },
  useAnyMedication: {
    label: 'Faz uso de algum medicamento?',
    name: 'useAnyMedication',
    type: 'text',
    value: ''
  }
}

let validations = {}

for (let field in formData) {
  validations[field] = {}
  validations[field].value = {}
  validations[field].value.required = required
}

export {formData, validations}
